import React, { useEffect } from "react";
import { type TradeInAemDispatchType, useTradeInAemSelector } from "../../../redux/store";
import { getInternalLink } from "../../../utils/navUtils";
import { TradeInAemLabel } from "../../../utils/labels";
import * as Styles from "../common/styles/TradeInAem";
import * as Form from "../../../../common-deprecated/styles/v2/toyota/components/Form";
import * as Flex from "../../../../common-deprecated/styles/v2/toyota/globals/Flex";
import * as Button from "../../../../common-deprecated/styles/v2/toyota/components/Button";
import * as Text from "../../../../common-deprecated/styles/v2/toyota/utilities/Text";
import ContactFormDealer from "./ContactFormDealer";
import ContactFormTextField from "./ContactFormTextField";
import ContactFormCheckbox from "./ContactFormCheckbox";
import { IconWrapper } from "../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import Icon from "../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import { useTradeInCsl } from "../../../csl/tradeInCslUtils";
import { TradeInAemContactFormId } from "../../../utils/constants";
import useTradeInAemContactForm from "../../../hooks/useTradeInAemContactForm";
import { trackStepContactForm } from "../../../utils/tracking";
import ContactFormPrivacyRadioButton from "./ContactFormPrivacyRadioButton";
import useTrackingParams from "../../../hooks/useTrackingParams";
import { useDispatch } from "../../../../shared-logic/redux/store";
import { showBackCtaOnStepComponent } from "../../../utils/utils";

const ContactFormContainer = (): JSX.Element => {
    const dispatch = useDispatch<TradeInAemDispatchType>();
    const currentStep = useTradeInAemSelector((state) => state.tradeInAemNav.step);
    const commonSettings = useTradeInAemSelector((state) => state.commonSettings);
    const contactFormData = useTradeInAemSelector((state) => state.tradeInAemContact);
    const tradeInAemModelSelect = useTradeInAemSelector((state) => state.tradeInAemModelSelect);

    const csl = useTradeInCsl();
    const prevStep = getInternalLink(csl, currentStep, dispatch, commonSettings, "prev");
    const nextStep = getInternalLink(csl, currentStep, dispatch, commonSettings, "next");

    const { showRequiredErrors, confirmClick } = useTradeInAemContactForm(nextStep);
    const trackingParams = useTrackingParams();

    useEffect(() => {
        trackStepContactForm(trackingParams, tradeInAemModelSelect);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Styles.Main>
            <Styles.Container>
                <ContactFormDealer />
                <Form.Form>
                    <TradeInAemLabel label="tradeInAemContactFormYourDetails" />
                    <Flex.Row mt={4}>
                        {contactFormData[TradeInAemContactFormId.FirstName] && (
                            <Flex.Col width={1} mb={3}>
                                <ContactFormTextField
                                    formItemId={TradeInAemContactFormId.FirstName}
                                    showRequiredError={showRequiredErrors}
                                />
                            </Flex.Col>
                        )}
                        {contactFormData[TradeInAemContactFormId.FirstLastName] && (
                            <Flex.Col
                                width={{
                                    xs: 1,
                                    md: contactFormData[TradeInAemContactFormId.SecondLastName] ? 1 / 2 : 1,
                                }}
                                mb={3}
                            >
                                <ContactFormTextField
                                    formItemId={TradeInAemContactFormId.FirstLastName}
                                    showRequiredError={showRequiredErrors}
                                />
                            </Flex.Col>
                        )}
                        {contactFormData[TradeInAemContactFormId.SecondLastName] && (
                            <Flex.Col width={{ xs: 1, md: 1 / 2 }} mb={3}>
                                <ContactFormTextField
                                    formItemId={TradeInAemContactFormId.SecondLastName}
                                    showRequiredError={showRequiredErrors}
                                />
                            </Flex.Col>
                        )}
                        {contactFormData[TradeInAemContactFormId.Address] && (
                            <Flex.Col width={{ xs: 8 / 12, md: 2 / 3 }} mb={3}>
                                <ContactFormTextField
                                    formItemId={TradeInAemContactFormId.Address}
                                    showRequiredError={showRequiredErrors}
                                />
                            </Flex.Col>
                        )}
                        {contactFormData[TradeInAemContactFormId.HouseNumber] && (
                            <Flex.Col width={{ xs: 4 / 12, md: 1 / 3 }} mb={3}>
                                <ContactFormTextField
                                    formItemId={TradeInAemContactFormId.HouseNumber}
                                    showRequiredError={showRequiredErrors}
                                />
                            </Flex.Col>
                        )}
                        {contactFormData[TradeInAemContactFormId.PostalCode] && (
                            <Flex.Col width={{ xs: 1, md: 1 / 2 }} mb={3}>
                                <ContactFormTextField
                                    formItemId={TradeInAemContactFormId.PostalCode}
                                    showRequiredError={showRequiredErrors}
                                />
                            </Flex.Col>
                        )}
                        {contactFormData[TradeInAemContactFormId.City] && (
                            <Flex.Col width={{ xs: 1, md: 1 / 2 }} mb={3}>
                                <ContactFormTextField
                                    formItemId={TradeInAemContactFormId.City}
                                    showRequiredError={showRequiredErrors}
                                />
                            </Flex.Col>
                        )}
                        {contactFormData[TradeInAemContactFormId.Email] && (
                            <Flex.Col width={{ xs: 1 }} mb={3}>
                                <ContactFormTextField
                                    formItemId={TradeInAemContactFormId.Email}
                                    showRequiredError={showRequiredErrors}
                                />
                            </Flex.Col>
                        )}
                        {contactFormData[TradeInAemContactFormId.Phone] && (
                            <Flex.Col width={{ xs: 1 }} mb={3}>
                                <ContactFormTextField
                                    formItemId={TradeInAemContactFormId.Phone}
                                    showRequiredError={showRequiredErrors}
                                />
                            </Flex.Col>
                        )}
                    </Flex.Row>
                    {contactFormData[TradeInAemContactFormId.PrivacyDisclaimers] &&
                        (contactFormData[TradeInAemContactFormId.PrivacyDisclaimers]?.visualization ===
                        "radiobutton" ? (
                            <ContactFormPrivacyRadioButton showRequiredErrors={showRequiredErrors} />
                        ) : (
                            <ContactFormCheckbox
                                formItemId={TradeInAemContactFormId.PrivacyDisclaimers}
                                showRequiredError={showRequiredErrors}
                            />
                        ))}
                    <Styles.ButtonWrapper stretchMobile spaceBetween>
                        {showBackCtaOnStepComponent(currentStep, csl.enabledNavSteps) && (
                            <Button.Link m={0} as="a" href={prevStep.href} onClick={prevStep.onClick} hasIcon>
                                <IconWrapper>
                                    <Icon variant="arrowLeft" />
                                </IconWrapper>
                                <Text.Button>
                                    <TradeInAemLabel label="tradeInAemBack" />
                                </Text.Button>
                            </Button.Link>
                        )}
                        <Button.Primary
                            mx={0}
                            mb={{ _: 2, md: 0 }}
                            width={{ _: 1, md: "auto" }}
                            type="submit"
                            onClick={confirmClick}
                        >
                            <Text.Button>
                                <TradeInAemLabel label="tradeInAemConfirm" />
                            </Text.Button>
                        </Button.Primary>
                    </Styles.ButtonWrapper>
                </Form.Form>
            </Styles.Container>
        </Styles.Main>
    );
};
export default ContactFormContainer;
